export enum KEY_CODE {
  ArrowRight = 'ArrowRight',
  ArrowLeft = 'ArrowLeft',
}
